import { FC } from "react";

const NotFoundSearchView: FC = (): JSX.Element => {
  return (
    <div className="text-xs text-center laptop:text-sm">
      検索条件に合致する結果は、見つかりませんでした。
    </div>
  );
};

export default NotFoundSearchView;
